import styled from 'styled-components';
import { $switchCaseStrict } from 'dolla-switch';

import { PseudoPlacement } from './Popup';

export default styled.div<{ background: string; placement: PseudoPlacement; size: number }>`
    position: absolute;
    width: ${({ size }) => size}px;
    height: ${({ size }) => size}px;
    ${({ placement, size }) =>
        $switchCaseStrict(placement, {
            top: () => `
          bottom: -${size}px;
        `,
            bottom: () => `
          top: -${size}px;
        `,
            left: () => `
          right: -${size}px;
        `,
            right: () => `
          left: -${size}px;
        `,
        })}

    &:after {
        content: '';
        position: absolute;
        width: 0;
        height: 0;
        pointer-events: none;
        ${({ background, placement, size }) =>
            $switchCaseStrict(placement, {
                top: () => `
                top: 0;
                left: -${size / 2}px;
                border-left: ${size}px solid transparent;
                border-right: ${size}px solid transparent;
                border-top: ${size}px solid ${background};
              `,
                bottom: () => `
                top: 0;
                left: -${size / 2}px;
                border-left: ${size}px solid transparent;
                border-right: ${size}px solid transparent;
                border-bottom: ${size}px solid ${background};
              `,
                left: () => `
                top: -${size / 2}px;
                left: 0;
                border-top: ${size}px solid transparent;
                border-bottom: ${size}px solid transparent;
                border-left: ${size}px solid ${background};
              `,
                right: () => `
                top: -${size / 2}px;
                left: 0;
                border-top: ${size}px solid transparent;
                border-bottom: ${size}px solid transparent;
                border-right: ${size}px solid ${background};
              `,
            })}
    }
`;
